import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css'


Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        icontfont: "mdi"
    },
    theme: {
        themes: {
            light: {
                primary: '#01579B'
            }
        }
    }
});